import { DataTable } from "primereact/datatable";
import { useCallback, useEffect, useState } from "react";
import { Column } from "primereact/column";
import Parameters from "../parameters/Parameters";
import csvDownload from "json-to-csv-export";
import { getTradesResponse } from "../../services/util/historicalComponentsResponses";
import { useDispatch, useSelector } from "react-redux";
import { setParams } from "../../store/historicalParamsSlice";
import './style.css';
import { GiSandsOfTime } from "react-icons/gi";
import { MdArrowRightAlt } from "react-icons/md";
import { toTitleCase } from "../../services/util/normalize";
import moment from "moment";
import { getModelWiseParams } from "../../services/util/backdatedParams";

import ProductNote from "../adviceStatus/productNote";
import { HiOutlineDownload } from 'react-icons/hi';
import { PDFDownloadLink } from '@react-pdf/renderer';
import { getTradeReason } from '../../api/otherEndPoints/necessoryEndPoints';
import BackParameters from "../parameters/BackParameters";
import { csvColumnMap, generaliseExportCSV, HistocalexportCSV, historiCalcsvColumnMap } from "../../services/util/util";
import GeneralisePreviewTable from "../adviceStatus/GeneralisePreviewTable";


const HistoricalDataTable = ({ filterDropdownVersion, type, startandEndDate, heatmapVersion, asset, tradetype, heatMapData}: any) => {
    const [filteredData, setFilteredData] = useState<any>([])
    const [parametersData, setParametersData] = useState<any>([]);
    const [formattedParametersData, setFormattedParametersData] = useState<any>([])
    const [selectedTrade, setSelectedTrade] = useState<any>(null)
    const dispatch = useDispatch();
    const theme: any = useSelector((state: any) => {
        return state.theme.isTheme;
    })
    const [tradeReason, setTradeReason] = useState<any>({});
    const[stockStrength, setStockStrength] = useState<string>('');


  //-------------------CSV PREVIEW-------------//
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [selectedPreviewTableData, setSelectedPreviewTableData] = useState<any[]>([]);
  const [selectedPreviewTableColumns, setSelectedPreviewTableColumns] = useState<any[]>([]);
  const [selectedPreviewTableColumnMapping, setSelectedPreviewTableColumnMapping] = useState<any>({});
  const [selectedFileName, setSelectedFileName] = useState<string>("");


  const memorizedExportCSV = useCallback(generaliseExportCSV,[isModalOpen,selectedPreviewTableData]);
  // const onDownload = useCallback(() => memorizedExportCSV(selectedPreviewTableData,selectedPreviewTableColumnMapping,"MonthlyReturns.csv"), [memorizedExportCSV,selectedPreviewTableData]);
  
  const backdatedpreviewTablecolumns= 
  [
    {
      title: "Code",
      dataIndex: "identifier",
      key: "Code",
      width:150
    },
    {
        title: "Open Date",
        dataIndex: "entry_date",
        key: "Open Date",
        width:150,
        render: (text: any) =>(
            <span>{moment(text).format("DD MMM YYYY")}</span>
        )
      },
    {
      title: "Close Date",
      dataIndex: "trade_close_date",
      key: "Close Date",
      width:150,
      render: (text: any, records: any) =>(
        <span>{records?.close_reason?.length > 0 ? text : ""}</span>
    )
    },
    {
      title: "Date",
      dataIndex: "dt_date",
      key: "Date",
      width:150
  
    },
    {
      title: "Entry Time",
      dataIndex: "dt_open_time",
      key: "Entry Time",
      width:100
  
    },
    {
      title: "Exit Time",
      dataIndex: "dt_end_time",
      key: "Exit Time",
      width:100
  
    },
    {
      title: "Expiry Date",
      dataIndex: "dt_expiry_date",
      key: "Expiry Date",
      width:100
  
    },
    {
      title: "Dividend List",
      dataIndex: "j_dividend_list",
      key: "Dividend List",
      width:150,
      render:(_:any,records:any)=>(
        <>
        {Array.isArray(records.j_dividend)
          ? records.j_dividend.map((item: any, idx: number) => 
              { 
              return <div key={idx}>{JSON.stringify(item)}</div>
            }
            )
          : String(records.j_dividend ?? [])}
        </>
      )
    },
    {
      title: "Target/Stoploss List",
      dataIndex: "j_target_stoploss",
      key: "Target/Stoploss List",
      width:200,
      render:(obj:any,_:any)=>{
        
        return(
        <>
        {obj ?
          Object.keys(obj)?.map((item:any)=>{
            for (const [key,value] of Object.entries(obj[item])){
             
               return <span>{`{time: ${item} ${key}: ${value}} `}</span>
            }
        }):<span>{`[]`}</span>
        }
      </>
      )}
  
    },
    {
      title: "Exit Price",
      dataIndex: "exit_price",
      key: "Exit Price",
      width:100
  
    },
    {
      title: "P/L",
      dataIndex: "trade_pl",
      key: "P/L",
      width:100
  
    },
    {
      title: "P/L (₹)",
      dataIndex: "trade_pl_rs",
      key: "P/L (₹)",
      width:100
  
    },
    {
      title: "Return",
      dataIndex: "n_return",
      key: "Return",
      width:100
  
    },
    {
      title: "Return After Cost",
      dataIndex: "n_return_after_cost",
      key: "Return After Cost",
      width:100
  
    },
    {
      title: "Strike Price",
      dataIndex: "strike_price",
      key: "Strike Price",
      width:100
  
    },
    {
      title: "Transaction Price",
      dataIndex: "transaction",
      key: "Transaction Price",
      width:100
  
    },
    {
      title: "One Day P/L",
      dataIndex: "oneDaypl",
      key: "One Day P/L",
      width:100
  
    },
    {
      title: "One Day Return Percentage",
      dataIndex: "oneDay_return_per",
      key: "One Day Return Percentage",
      width:100
  
    },
    {
      title: "Option Type",
      dataIndex: "option_type",
      key: "Option Type",
      width:100
  
    },
    {
      title: "Status",
      dataIndex: "close_reason",
      key: "Status",
      width:100
  
    },
    {
      title: "Symbol",
      dataIndex: "asset",
      key: "Symbol",
      width:100
  
    },
    {
      title: "Trade Type",
      dataIndex: "tradetype",
      key: "Trade Type",
      width:100
  
    }
  ]
 

    useEffect(() => {
        if (startandEndDate !== null) {
            const getTradesData = async () => {
                setSelectedTrade(null)
                setFilteredData([]);
                
                setParametersData([]);
                setFormattedParametersData([]);
                
                let tradeResponse: any = await getTradesResponse(type, startandEndDate?.start_date, startandEndDate?.end_date, heatmapVersion, tradetype, asset, filterDropdownVersion)

                if(tradeResponse?.length>0){
                    tradeResponse?.forEach((item: any) => {
                        item.symbol           = item?.asset
                        item.asset            = (item?.asset)?.split('-')[0]
                        item.exit_price       = (item?.identifier?.slice(0,-1) === "AIONIFKKI") ? Number(item?.exit_price).toFixed(2) : Number(item?.exit_price).toFixed(2)
                        item.transaction      = (item?.identifier?.slice(0,-1) === "AIONIFKKI") ? Number(item?.transaction).toFixed(2) : Number(item?.transaction).toFixed(2)
                        item.trade_pl         = Number(item?.trade_pl).toFixed(2)
                        item.trade_pl_rs      = Number(item?.trade_pl_rs).toFixed(2)
                        item.close_reason     = toTitleCase(item?.close_reason)
                        item.open_date        = moment(item?.open_date).format("DD MMM YYYY")
                        item.trade_close_date = moment(item?.trade_close_date).format("DD MMM YYYY")
                    })
                    setFilteredData(tradeResponse)
                    setParametersData(tradeResponse[0])
                    let parameterResponse: any = normalizeHistoricalParameter(tradeResponse[0])
                    setFormattedParametersData(parameterResponse)
                    dispatch(setParams(tradeResponse[0]))
                }
            };
            getTradesData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startandEndDate, heatmapVersion,asset])


    const normalizeHistoricalParameter = (row: any) => {
        let paramsArray: any = [];
        if (row !== undefined) {
            {
                row['j_target_stoploss'] && Object.keys(row['j_target_stoploss']).map((item: any) => {
                    
                    if ((row['j_target_stoploss'])[item]['Target'] !== undefined && (row['j_target_stoploss'])[item]['Stoploss'] !== undefined) {
                        paramsArray.push({ 'dt_open_time': item, 'target': (row['j_target_stoploss'])[item]['Target'], 'stoploss': (row['j_target_stoploss'])[item]['Stoploss'] })
                    }
                    else if ((row['j_target_stoploss'])[item]['Target'] !== undefined && (row['j_target_stoploss'])[item]['Stoploss'] === undefined) {
                        paramsArray.push({ 'dt_open_time': item, 'target': (row['j_target_stoploss'])[item]['Target'] })
                    }
                    else if ((row['j_target_stoploss'])[item]['Target'] === undefined && (row['j_target_stoploss'])[item]['Stoploss'] !== undefined) {
                        paramsArray.push({ 'dt_open_time': item, 'stoploss': (row['j_target_stoploss'])[item]['Stoploss'] })
                    }
                })
            }

            return paramsArray
        } else {
            return []
        }

    }

    {
        parametersData?.length > 0 &&
            parametersData?.map((ts: any, idx: any) => {

                return (
                    <section key={idx}>
                        <BackParameters ts_value={ts} />
                    </section>
                );
            })
    }

    const columns = [
        { field: "asset", header: "Symbol" },
        { field: "identifier", header: "Code" },
        { field: "open_date", header: "Open Date" },
        { field: "trade_close_date", header: "Close Date" },
        { field: "transaction", header: "Transaction" },
        { field: "exit_price", header: "Exit Price" }

    ];

    const [visibleColumns, setVisibleColumns] = useState(columns);

    const getFontColorAsPerValue = (value: any) => {
        if (theme === 'light') {
            return value >= 0 ? '#338f33' : "orangered";
        }
        else if (theme === 'dark') {
            return value >= 0 ? "lightgreen" : "orangered";
        }
        else if (theme === 'b&w') {
            return value >= 0 ? 'lightgreen' : "orangered";
        }
    }

    const handlevalue: any = (identifier: any, value: any, valuesType: any) => {
        let returnValue: any;
        if (value === '' || value === undefined || value === null) {
            return ''
        }

        returnValue = Number(value)?.toFixed(2)

        if (valuesType === 'index') {
            if (returnValue >= 0) {
                return <span style={{ color: getFontColorAsPerValue(returnValue), fontWeight: 'bold' }}>{returnValue}</span>
            }
            else if (returnValue < 0) {
                return <span style={{ color: getFontColorAsPerValue(returnValue), fontWeight: 'bold' }}>{returnValue}</span>
            }
            else if (returnValue === '') {
                return <span></span>
            }
            else {
                return <span style={{ color: "whitesmoke", fontWeight: 'bold' }}>{returnValue}</span>
            }
        } else {
            return returnValue
        }
    }

    // const header = (
    //     <>
    //         <div className="params_btn">
    //             <div className="adviceStatus_table_option_div">
    //                 <span className="text">Historical Advice</span>
    //                 <div className="table_options">
    //                     <button
    //                         className="btn btn-sm btn-neutral mr-2"
    //                         onClick={() => exportCSV(false)}
    //                     >
    //                         <i className="pi pi-download"></i>
    //                     </button>
    //                 </div>
    //             </div>
    //         </div>
    //     </>
    // );
    const header = (
        <>
            <div className="params_btn">
            <GeneralisePreviewTable
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                columnHeader={selectedPreviewTableColumns}
                tableData={selectedPreviewTableData}
                onDownload={()=>{memorizedExportCSV(selectedPreviewTableData, selectedPreviewTableColumnMapping, selectedFileName)}}
            />
                <div className="adviceStatus_table_option_div">
                    <span className="text">Historical Advice</span>
                    <div className="table_options">
                        <button
                            className="btn btn-sm btn-neutral mr-2"
                            onClick={()=>{
                                setSelectedPreviewTableData(filteredData);
                                setSelectedPreviewTableColumns(backdatedpreviewTablecolumns);
                                setSelectedPreviewTableColumnMapping(historiCalcsvColumnMap);
                                setSelectedFileName("Historical Trades Details.csv")
                                setIsModalOpen(true);
                            
                            }}
                        >
                            <i className="pi pi-download"></i>
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
    
    const handleStatus:any = (item:any) =>{
        if (item == '' || item == null){
            return 'Open'
        }
        else{
            return item
        }
    }

    const backDatedActiveTrade = (item: any) => {
        if (item?.close_reason === undefined || item?.close_reason === null || item?.close_reason === '' || item?.close_reason === 'Open') {
          return 'openTrade'
        }
      }
      
    const csvDataMaker = (e: any) => {
        e.preventDefault();
        const dataToConvert = {
            data: filteredData,
            filename: `HistoricalTrades`,
            delimiter: ",",
            headers: [
                "s_code",
                "s_symbol",
                "Open Date",
                "Close Date",
                "Entry Time",
                "Exit Time",
                "Transaction",
                "Exit Price",
                "P/L",
                "P/L (₹)",
                "Return",
                "Return After Cost (%)",
                "Status",
            ],
        };
        csvDownload(dataToConvert);
    };

    const selectedRow: any = (event: any) => {
        let formattedParametersResponse: any = normalizeHistoricalParameter(event?.data)
        setParametersData(event?.data)
        setFormattedParametersData(formattedParametersResponse)
        dispatch(setParams(event?.data))
    }

    // NEW FOR STRENGTH
    const findStrength=(heatMapData:any,parametersData:any)=>{
        let strengthReason:string  = "";
        let returnPercent:any = heatMapData?.find((item:any)=> item?.identifier == parametersData?.identifier)
        returnPercent         = Number(returnPercent?.pl_percentage);
        if (returnPercent < 21) strengthReason = "Conservative";
        else if (returnPercent <= 30) strengthReason = "Normal";
        else if (returnPercent > 30) strengthReason = "Aggressive";
        setStockStrength(strengthReason);

        return strengthReason;
    }

    useEffect(()=>{
        const fetchData = async()=>{
            let tradeReasonResp:any = {};
            setTradeReason({})
            try{
                if(Array.isArray(parametersData) ? parametersData.length > 0 : Object.keys(parametersData).length > 0){
                    let date:string   = parametersData['open_date'] || '';
                    let symbol:string = parametersData['asset'] || '';
                    let time:string   = parametersData['dt_open_time']||'';

                    tradeReasonResp = await getTradeReason(date,symbol,time);
                }
            }catch{
                setTradeReason({});
            }
            // NEW FOR STRENGTH
            let strengthReason:string = '';
            try{
                setStockStrength('');
                strengthReason = findStrength(heatMapData,parametersData);
            }catch{
                setStockStrength('');
            }
            if(Object.keys(tradeReasonResp).length>0){
                setTradeReason({...tradeReasonResp,strength: strengthReason});
            }
        }
        fetchData();
      },[parametersData])
      

    useEffect(()=>{
        // NEW FOR STRENGTH
        try{
            let strengthReason:string = findStrength(heatMapData,parametersData);
            if(Object.keys(tradeReason).length>0){
                setTradeReason((prevTradeReason: any) => ({
                    ...prevTradeReason,
                    strength: strengthReason,
                }));
            }
        }catch{
            setStockStrength('');
        }
    },[heatMapData])   
    
    return (
        <>
            <div className="adviceStatus_mainContainer">
                <div className="adviceStatus_table">
                    <div className="table_card adviceStatus_margin">
                        <DataTable
                            value={filteredData}
                            header={header}
                            id="selected_row"
                            className="eq"
                            scrollable
                            selectionMode="single"
                            selection={selectedTrade || filteredData[0]}
                            onSelectionChange={(e: any) => {e.value &&setSelectedTrade(e.value)}}
                            dataKey="uuid"
                            onRowSelect={selectedRow}
                            columnResizeMode="expand"
                            resizableColumns
                            reorderableRows
                            reorderableColumns
                            onRowReorder={(e) => setFilteredData(e.value)}
                            removableSort
                            tableStyle={{ minWidth: "50rem" }}
                            rowClassName={backDatedActiveTrade}
                        >
                            <Column className="reorder" rowReorder style={{ width: "3rem" }} />
                            {visibleColumns.map((col) => (
                                <Column
                                    sortable={['transaction', 's_status', 'exit_price'].includes(col.field) ? false : true}
                                    key={col.field}
                                    field={col.field}
                                    header={col.header}
                                />
                            ))}
                            <Column sortable field="close_reason" header="Status" body={(e: any) => handleStatus(e.close_reason)} />
                            <Column sortable field="trade_pl_rs" header="P/L (₹)" body={(e: any) => handlevalue(e.identifier, !['equityMultiday','equityN50BANK'].includes(type) ? Number(e.trade_pl_rs).toFixed(2) : Number(e.trade_pl)?.toFixed(2), "index")} />
                            <Column sortable field="trade_pl" header="P/L" body={(e: any) => handlevalue(e.identifier, Number(e.trade_pl)?.toFixed(2), "index")} />
                            <Column sortable field="return" header="Return (%)" body={(e: any) => handlevalue(e.identifier, Number(e.return)?.toFixed(2), "index")} />
                            <Column sortable field="return_ac" header="Return After Cost (%)" body={(e: any) => handlevalue(e.identifier, Number(e.return_ac)?.toFixed(2), "index")} />
                        </DataTable>
                    </div>
                </div>
                {/* advice_status_param */}
                <div className="adviceStatus_params_div">
                    <div className="params_content_historical">
                        <h4 className="adviceStatus_params_heading">Details</h4>
                        <div className="adviceStatus_under_params_heading">
                            {
                                parametersData ?
                                <>
                                <h6 style={{ fontFamily: "monospace" }}>
                                    {/* {parametersData?.identifier === undefined ? "" : (parametersData?.identifier)?.slice(0, 3) === 'QEB'?(parametersData?.identifier)?.slice(3):(parametersData?.identifier)?.slice(1, 3) === 'ES' ? parametersData?.asset?.split('-')[0] : getModelWiseParams(parametersData?.identifier.includes('-')? (parametersData?.identifier)?.split('-')[0]?.slice(0, -1)+'-'+(parametersData?.identifier)?.split('-')[1]:(parametersData?.identifier)?.slice(0, -1))} */}
                                    {parametersData?.identifier === undefined ? "" : (parametersData?.identifier)?.slice(0, 3) === 'QEB'?parametersData?.asset?.split('-')[0]:(parametersData?.identifier)?.slice(1, 3) === 'ES' ? parametersData?.asset?.split('-')[0] : getModelWiseParams(parametersData?.identifier.includes('-')? (parametersData?.identifier)?.split('-')[0]?.slice(0, -1)+'-'+(parametersData?.identifier)?.split('-')[1]:(parametersData?.identifier)?.slice(0, -1))}
                                    <span className="detailsSymbol"> {parametersData?.identifier}</span>
                                </h6>
                                <h6 className="mb-3 trade_time"><GiSandsOfTime />
                                    {(type === 'equityMultiday'||type === 'equityN50BANK') ? (moment(parametersData?.open_date).format("DD MMM YYYY ")) : ''} {(parametersData?.dt_open_time)}
                                    <MdArrowRightAlt />
                                    {(type === 'equityMultiday'||type === 'equityN50BANK') ? (moment(parametersData?.trade_close_date).format("DD MMM YYYY ")) : ''} {parametersData?.dt_end_time === '' ? 'Trade is open' : (parametersData?.dt_end_time)}</h6>
                                
                                {(parametersData?.identifier!= undefined &&parametersData?.identifier?.slice(1, 3) === 'ES') &&<h6 style={{fontFamily:"monospace" }} >
                                <span className="font-semibold">Strength </span>{stockStrength}
                                </h6>}
                                <span>
                                    {parametersData?.identifier?.slice(2, 3) === 'O' ? <div className="font-semibold" >
                                        {parametersData?.option_type} Strike <MdArrowRightAlt /> 
                                        {parametersData?.option_type === 'CE' ? parametersData?.strike_price_ce : parametersData?.strike_price_pe}
                                        </div> : ''}
                                </span>
                                {(parametersData?.dividend !== undefined && parametersData?.dividend !== null) && Object.keys(parametersData?.dividend)?.length > 0 && <span className="font-semibold">Dividend</span>}
                                {(parametersData?.dividend !== undefined && parametersData?.dividend !== null) && Object.keys(parametersData?.dividend)?.length > 0 ?
                                    Object.keys(parametersData?.dividend)?.map((item: any) => {
                                        return (
                                            <>
                                                <br />
                                                <span className="font-semibold" style={{ color: `${theme === 'light' ? "#615b5b" : 'white'}` }}>{item} <MdArrowRightAlt /> <span style={{ color: getFontColorAsPerValue(parametersData?.dividend[item]) }}>{parametersData?.dividend[item]}</span></span>
                                            </>
                                        )
                                    }) : ''}
                                {parametersData?.identifier?.slice(2, 3) === 'O' ? <p className="font-semibold" > Expiry Date <MdArrowRightAlt /> {parametersData?.expiry_date}</p> : ''}
                                {(parametersData?.dividend !== undefined && parametersData?.dividend !== null) && Object.keys(parametersData?.dividend)?.length > 0 && <br />}
                                {parametersData?.s_defination === 'previously_open'? <div>
                                    <span className="trade_time">Original Trade Details</span>
                                    <br />
                                        <span className="trade_time">
                                            <GiSandsOfTime />
                                            {type === 'equityMultiday' || type === 'equityN50BANK' ? (moment(parametersData?.entry_date).format("DD MMM YYYY ")) : ''} {(parametersData?.open_time)}
                                            <MdArrowRightAlt />
                                            {type === 'equityMultiday' || type === 'equityN50BANK' ? (moment(parametersData?.trade_close_date).format("DD MMM YYYY ")) : ''} {parametersData?.dt_end_time === '' ? 'Trade is open' : (parametersData?.dt_end_time)}
                                        </span>
                                    <br/>
                                    <span className="trade_time">Entry: {parametersData?.entryprice?.toFixed(2)},  Exit: {parseInt(parametersData?.exit_price)?.toFixed(2)}</span>
                                    <br/>
                                    <span className="trade_time" >PL: <span style={{color: getFontColorAsPerValue(parametersData?.total_pl)}}>{parametersData?.total_pl?.toFixed(2)}</span> (<span style={{color: getFontColorAsPerValue(parametersData?.n_return_after_cost)}}>{parametersData?.n_return?.toFixed(2)}%</span>)</span>
                                    <br/>
                                    <span className="trade_time">Return after cost: <span style={{color: getFontColorAsPerValue(parametersData?.n_return_after_cost)}}>{parametersData?.n_return_after_cost?.toFixed(2)}%</span></span>

                                </div>: <div></div>}
                                <span className="font-semibold" style={{ marginTop: "0.2rem", fontFamily: "monospace" }}>Target & Stoploss</span>
                                {formattedParametersData?.length > 0 &&
                                    formattedParametersData?.map((ts: any, idx: any) => {
                                        return (
                                            <section key={idx}>
                                                <BackParameters ts_value={ts} />
                                            </section>
                                        );
                                    })}
                                    </>
                                    :
                                    <></>
                            }
                        </div>

                    </div>
                    {((type==='equityMultiday'|| type === 'equityN50BANK') && Object.keys(tradeReason).length>2) &&
                        <PDFDownloadLink document={<ProductNote tradeReason={tradeReason}/>} fileName={`${tradeReason['s_symbol']}_${tradeReason['dt_date']}.pdf`}>
                            <div className="pdfDownloadStyle">
                            Product note<HiOutlineDownload size={20}/>
                            </div>
                        </PDFDownloadLink>
                    }
                </div>
                {/* advice_status_param end*/}

            </div>
        </>
    )
}
export default HistoricalDataTable